import React, { useEffect, useState, useRef } from "react";
import "./Leaderboard.css";
import { X } from "lucide-react";

/* realistic name lists */
const male = [
  "James Miller","Daniel Smith","Michael Johnson","David Brown",
  "Andrew Wilson","Matthew Davis","Christopher Lee","Joshua Taylor",
  "Joseph Anderson","Ryan Thomas"
];

const female = [
  "Mia Lopez","Charlotte Gonzalez","Amelia Perez","Harper Sanchez",
  "Evelyn Ramirez","Olivia Johnson","Sophia Martinez","Isabella Garcia",
  "Ava Rodriguez","Emma Lewis"
];

function randInt(min, max) { return Math.floor(Math.random() * (max - min + 1)) + min; }
function randBalance() { return (randInt(50_000, 900_000) + Math.random()).toFixed(2); }
function randDelta() { return (Math.random() * 20000 - 8000).toFixed(2); }
function avatarUrl(i) { return `https://i.pravatar.cc/64?img=${10 + (i % 70)}`; }
function traderId() { return `#${Math.floor(1000000000 + Math.random() * 8999999999)}`; }

export default function Leaderboard({ open, onClose }) {
  const [list, setList] = useState([]);
  const intervalRef = useRef(null);

  /* INITIALIZE */
  useEffect(() => {
    const initial = Array.from({ length: 10 }).map((_, i) => {
      const isFemale = i % 3 === 0;
      const name = isFemale ? female[i % female.length] : male[i % male.length];
      return {
        id: traderId(),
        rank: i + 1,
        name,
        avatar: avatarUrl(i),
        balance: Number(randBalance()),
        delta: Number(randDelta())
      };
    });
    setList(initial);
  }, []);

  /* LIVE UPDATES */
  useEffect(() => {
    if (!open) return;

    intervalRef.current = setInterval(() => {
      setList(prev => {
        const next = prev.map(item => ({ ...item }));
        const updates = randInt(2, 4);

        for (let k = 0; k < updates; k++) {
          const idx = randInt(0, next.length - 1);
          const change = [100, 200, 500, 1000][randInt(0, 3)] * (Math.random() < 0.7 ? 1 : -1);

          next[idx].balance = Math.max(1000, Number((next[idx].balance + change).toFixed(2)));
          next[idx].delta = Number(change.toFixed(2));
        }

        next.sort((a, b) => b.balance - a.balance);
        next.forEach((item, i) => (item.rank = i + 1));
        return next;
      });
    }, 1000);

    return () => clearInterval(intervalRef.current);
  }, [open]);

  if (!open) return null;

  return (
    <div className="leaderboardPanel show">
      <div className="leaderboard-header">
        <h4>Top Traders</h4>
        <button className="close-x" onClick={onClose}><X size={18} /></button>
      </div>

      <div className="leaderboard">
        {/* SCROLL FIX ADDED HERE */}
        <div className="scroll-area">
          <ul className="leaderboard-list">
            {list.map(u => (
              <li className="leaderboard-item" key={u.id}>
                <div className="rank">{u.rank}</div>
                <img className="avatar" src={u.avatar} alt={u.name} />

                <div className="meta">
                  <div className="name">{u.name}</div>
                  <div className="small">{u.id}</div>
                </div>

                <div className="balanceWrap">
                  <div className={`balance ${u.delta >= 0 ? "up" : "down"}`}>
                    ${u.balance.toLocaleString()}
                  </div>
                  <div className="delta">
                    {u.delta >= 0 ? "+" : ""}
                    {u.delta.toLocaleString()}
                  </div>
                </div>
              </li>
            ))}
          </ul>
        </div>

        <div className="leaderboard-footer">Updated live — refresh every 1s</div>
      </div>
    </div>
  );
}
